import React from 'react'

import { useSelector, useDispatch } from 'react-redux'

import { withRouter } from 'react-router-dom'

import { withStyles, makeStyles } from '@material-ui/core/styles'

import Tooltip from '@material-ui/core/Tooltip'
import Checkbox from '@material-ui/core/Checkbox'
import CheckboxIcon from '@material-ui/icons/CheckBox'
import AddBoxIcon from '@material-ui/icons/AddBox'

import SourceIcon from '../tools/SourceIcon'
import { truncateText } from '../../../utils'

import queryString from 'query-string'
import moment from 'moment'
import { FormControlLabel, Grid, Avatar, Button } from '@material-ui/core'
import FlagIcon from '@material-ui/icons/Flag'

import { setFromView } from '../../../redux/actions'
import { QuarantineSubBanner } from '../tools'
import { toggleImage } from '../../../utils/functions/toggleFunctions'

const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 12,
    leavTouchDelay: 10000
  }
}))(Tooltip)

const BlueCheckbox = withStyles((theme) => ({
  root: {
    color: '#3984f7',
    padding: 0,
    '&$checked': {
      color: '#3984f7'
    }
    // '&:not($checked) .MuiIconButton-label:after': {
    //   content: '""',
    //   left: 4,
    //   top: 4,
    //   height: 15,
    //   width: 15,
    //   position: 'absolute',
    //   backgroundColor: 'white',
    //   zIndex: -1
    // }
  },
  checked: {}
}))(Checkbox)

const useStyles = makeStyles(theme => ({
  buttonContainer: {
    position: 'absolute',
    zIndex: 1
    // width: '3em',
    // height: '3em'
  },
  checkIcon: {
    fill: '#3984f7',
    fontSize: '1.5em'
  },
  uncheckIcon: {
    fill: '#fff',
    color: '#000',
    fontSize: '1.5em'
  },
  checkCoverIcon: {
    width: '1em',
    height: '1em',
    margin: 'auto',
    position: 'absolute',
    zIndex: -1,
    backgroundColor: '#fff'
  },
  uncheckCoverIcon: {
    width: '1.25em',
    height: '1.25em',
    margin: 'auto',
    position: 'absolute',
    zIndex: -1,
    borderRadius: '0.25em',
    // backgroundColor: '#000',
    border: '#3984f7 16px solid'
  },
  flagContainer: {
    position: 'absolute',
    height: 'auto',
    width: 'auto',
    zIndex: 1,
    right: 0,
    top: '88%',
    pointerEvents: 'none'
  },
  flagAvatar: {
    backgroundColor: theme.palette.error.light
  },
  dataButton: {
    padding: theme.spacing(0),
    fontSize: theme.spacing(1.5),
    marginTop: 'auto',
    marginBottom: 'auto'
  }
}))

/**
 * Creates a modal that displays capture detail information
 * @param {Object} capture capture data based on the currently selected capture
 */
const GridView = props => {
  const {
    index, capture, getSeverityClass, formatBorderClass,
    handleQuickFilter, getSourceDescription
  } = props

  const classes = useStyles()
  const dispatch = useDispatch()

  const Captures = useSelector(state => state.violations.violations.captures)
  const PageLimit = useSelector(state => state.selection.PageCaptureLimit)

  const parsedProps = queryString.parse(props.location.search)
  const MatchPage = parseInt(parsedProps.page)
  const activeCaptures = JSON.parse(parsedProps.activeCaptures)

  // uses pagination settings to calculate the correct number of the violation to redirect to
  const calculateCaptureNumber = (index) => {
    if (isNaN(parseInt(index))) { return 0 }
    return index + (parseInt(PageLimit, 10) * (MatchPage - 1))
  }

  const handleClick = () => {
    if (capture.violationID) {
      const CaptureIndex = Captures.findIndex((violations) => {
        return violations.violationID === capture.violationID
      }) + 1

      dispatch(setFromView('grid'))

      props.history.push({
        pathname: '/captures',
        search: `?view=single&capture=${calculateCaptureNumber(CaptureIndex)}`
      })
    }
  }

  const toggleUsername = () => {
    if (capture.username) {
      return (
        <LightTooltip title={capture.username} placement='right'>
          <Button
            variant='text'
            color='primary'
            className={classes.dataButton}
            style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}
            onClick={(e) => { e.preventDefault(); handleQuickFilter({ username: capture.username }) }}
          >
            {truncateText(`${capture.username ? capture.username : <span className='unselectable'>'N/A'</span>}`)}
          </Button>
        </LightTooltip>
      )
    } else {
      return (
        <p className='grid-view-text'>N/A</p>
      )
    }
  }

  const toggleCategory = () => {
    if (capture.categoryName) {
      return (
        <LightTooltip title={capture.categoryName} placement='right'>
          <Button
            variant='text'
            color='primary'
            className={classes.dataButton}
            style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}
            onClick={(e) => { e.preventDefault(); handleQuickFilter({ categoryName: capture.categoryName }) }}
          >
            {truncateText(`${capture.categoryName ? capture.categoryName : 'N/A'}`)}
          </Button>
        </LightTooltip>
      )
    } else {
      return (
        <p className='grid-view-text'>N/A</p>
      )
    }
  }

  const togglePhrase = () => {
    if (capture.phrase) {
      return (
        <LightTooltip title={capture.phrase} placement='right'>
          <Button
            variant='text'
            color='primary'
            className={classes.dataButton}
            style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}
            onClick={(e) => { e.preventDefault(); handleQuickFilter({ phrase: capture.phrase }) }}
          >
            {`${truncateText(`${capture.phrase ? capture.phrase : 'N/A'}`)}${capture.multiple_phrases ? '*' : ''}`}
          </Button>
        </LightTooltip>
      )
    } else {
      return (
        <p className='grid-view-text'>N/A</p>
      )
    }
  }

  const handleInputCheck = (e, violationKey) => {
    const violationIndex = activeCaptures.indexOf(calculateCaptureNumber(index))

    if (violationIndex !== -1) {
      activeCaptures.splice(violationIndex, 1)
    } else {
      const actualCapture = calculateCaptureNumber(index)
      activeCaptures.push(actualCapture)
    }

    activeCaptures.sort()
    props.history.push({
      pathname: '/captures',
      search: `?view=grid&page=${MatchPage}&activeCaptures=${JSON.stringify(activeCaptures)}`
    })
  }

  return (
    <div
      className={`card dynamic-card mx-2 my-2 grid-capture ${formatBorderClass(capture.statusFlag)}`}
      id={index}
      data-violationkey={capture.violationID}
    >
      {capture.isFlagged
        ? (
          <Grid container direction='row' className={classes.flagContainer}>
            <Avatar variant='rounded' className={classes.flagAvatar}>
              <FlagIcon />
            </Avatar>
          </Grid>
        )
        : (<></>)}
      <div className='align-items-center'>
        <div className={classes.buttonContainer}>
          <FormControlLabel
            control={
              <BlueCheckbox
                checked={activeCaptures.indexOf((parseInt(PageLimit, 10) * (MatchPage - 1)) + index) !== -1}
                onClick={(e) => handleInputCheck(e, capture.violationID)}
                checkedIcon={
                  <>
                    <CheckboxIcon className={`${classes.checkIcon} checkbox-input`} />
                    <div className={`${classes.checkCoverIcon} checkbox-input`} />
                  </>
                }
                icon={
                  <>
                    <div className={`${classes.uncheckCoverIcon} checkbox-input`} />
                    <AddBoxIcon className={`${classes.uncheckIcon} checkbox-input`} />
                  </>
                }
              />
            }
            className='m-0 w-100 h-100'
          />
        </div>
        <span id='severity-badge' className={getSeverityClass(capture.severity)}>{capture.severity}</span>
        <div className='image-container'>
          {toggleImage(capture, false, null, 'grid-image', { onClick: handleClick })}
          <div className='hover-tip-container'>
            <div className='hover-helper'>
              <div className='row justify-content-center'>
                <img
                  alt=''
                  src='data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDQ5MC4yIDQ5MC4yIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA0OTAuMiA0OTAuMjsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHdpZHRoPSI1MTJweCIgaGVpZ2h0PSI1MTJweCI+CjxnPgoJPGc+CgkJPHBhdGggZD0iTTQxOC41LDQxOC41Yzk1LjYtOTUuNiw5NS42LTI1MS4yLDAtMzQ2LjhzLTI1MS4yLTk1LjYtMzQ2LjgsMHMtOTUuNiwyNTEuMiwwLDM0Ni44UzMyMi45LDUxNC4xLDQxOC41LDQxOC41eiBNODksODkgICAgYzg2LjEtODYuMSwyMjYuMS04Ni4xLDMxMi4yLDBzODYuMSwyMjYuMSwwLDMxMi4ycy0yMjYuMSw4Ni4xLTMxMi4yLDBTMywxNzUuMSw4OSw4OXoiIGZpbGw9IiNGRkZGRkYiLz4KCQk8cGF0aCBkPSJNMjQ1LjEsMzM2LjljMy40LDAsNi40LTEuNCw4LjctMy42YzIuMi0yLjIsMy42LTUuMywzLjYtOC43di02Ny4zaDY3LjNjMy40LDAsNi40LTEuNCw4LjctMy42YzIuMi0yLjIsMy42LTUuMywzLjYtOC43ICAgIGMwLTYuOC01LjUtMTIuMy0xMi4yLTEyLjJoLTY3LjN2LTY3LjNjMC02LjgtNS41LTEyLjMtMTIuMi0xMi4yYy02LjgsMC0xMi4zLDUuNS0xMi4yLDEyLjJ2NjcuM2gtNjcuM2MtNi44LDAtMTIuMyw1LjUtMTIuMiwxMi4yICAgIGMwLDYuOCw1LjUsMTIuMywxMi4yLDEyLjJoNjcuM3Y2Ny4zQzIzMi44LDMzMS40LDIzOC4zLDMzNi45LDI0NS4xLDMzNi45eiIgZmlsbD0iI0ZGRkZGRiIvPgoJPC9nPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo='
                  className='hover-tip-image'
                />
                {/* <AddCircleOutline className='hover-tip-image' /> */}
                <p className='hover-tip-text'>Click Image to View Full</p>
              </div>
            </div>
          </div>
        </div>
        {capture.quarantined && <QuarantineSubBanner redacted={capture.redacted} fontSize={12} />}
        <div className='card-body card-body-grid text-center'>
          <div className='d-flex flex-column col-12 px-0'>
            <div className='row my-1 mx-auto w-100'>

              <div className='d-flex flex-column col-7'>
                <div className='row justify-content-start my-auto'>
                  <p className='card-text unselectable my-auto'>Word/Phrase:</p>
                  {togglePhrase()}
                </div>
              </div>

              <div className='d-flex flex-column col-5'>
                <div className='row justify-content-start my-auto'>
                  <p className='card-text-right unselectable my-auto'>Source:</p>
                  {SourceIcon(getSourceDescription(capture.source), handleQuickFilter)}
                </div>
              </div>

            </div>

            <div className='row my-1 mx-auto w-100'>

              <div className='d-flex flex-column col-7'>
                <div className='row justify-content-start my-auto'>
                  <p className='card-text unselectable my-auto'>Category:</p>
                  {toggleCategory()}
                </div>
              </div>

              <div className='d-flex flex-column col-5'>
                <div className='row justify-content-start my-auto'>
                  <p className='card-text-right unselectable my-auto'>User:</p>
                  {toggleUsername()}
                </div>
              </div>

            </div>

            <div className='row my-1 mx-auto w-100'>
              <div className='col-10'>
                <div className='row justify-content-start'>
                  <p className='unselectable' style={{ marginBottom: '.8rem', color: 'black', fontSize: '.7em', marginRight: '.3rem', marginTop: '.3rem' }}>Date/Time:</p>
                  <span className='unselectable' style={{ fontSize: '.8em', color: 'black', marginTop: '.3rem' }}>
                    {capture.reportedAt ? moment.unix(capture.reportedAt / 1000).format('MM/DD/YYYY LT') : 'N/A'}
                  </span>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  )
}

export default withRouter(GridView)
